/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import isArray from "lodash/isArray";
import cx from "classnames";

import Card from "wonderbly-components/lib/Card";
import RichText from "../Prismic/RichText";
import SectionHeading from "../SectionHeading";
import ProductGridMarketingCard from "./ProductGridMarketingCard";

import "./ProductGrid.scss";

const sizeOptions = ["extra-small", "small", "medium", "large"];
let largeCardCount = 0;

const getProductCard = ({
  ageRangeLabel,
  product,
  priceLabel,
  savings,
  url,
  showProductTags,
  productTags,
}) => {
  const {
    productInformation: { title, image, productBadgeContent },
    main: { productId },
  } = product;

  return (
    <Card
      large
      key={productId}
      ageRange={ageRangeLabel}
      body={productBadgeContent}
      image={image.url}
      imageBackgroundColour="kraft-paper"
      imageBackgroundSize="contain"
      price={priceLabel}
      priceOriginal={savings && savings.was_price.formatted}
      title={title}
      href={url}
      tags={showProductTags ? productTags : []}
    />
  );
};

const ProductGrid = (props) => {
  const isCondensed = props.items.length >= 6;
  const marketingOnlyGrid = !props.items.find((item) => !item.isMarketingCard);
  return (
    <section
      className={cx("product-grid container-guttered", {
        "product-grid--no-margin-top": props.noMarginTop,
      })}
    >
      <SectionHeading tag="h4">{props.title}</SectionHeading>
      {!isEmpty(props.description) && (
        <div className="product-grid__description">
          {isArray(props.description) ? (
            <RichText fields={props.description} />
          ) : (
            props.description
          )}
        </div>
      )}
      <div
        className={cx(
          { "product-grid--marketing-only": marketingOnlyGrid },
          { "product-grid--showcase": !marketingOnlyGrid && !isCondensed },
          { "product-grid--condensed": !marketingOnlyGrid && isCondensed }
        )}
      >
        {props.items.map((item, idx) => {
          if (item.size === "large") {
            largeCardCount += 1;
          }
          return (
            <div
              key={item.product.main.uid}
              className={cx(
                `product-grid-card product-grid-card--${item.size}`,
                { "product-grid-card--marketing": item.isMarketingCard }
              )}
            >
              {item.isMarketingCard ? (
                <ProductGridMarketingCard
                  {...item.product}
                  key={item.product.main.uid}
                  isMarketingOnly={marketingOnlyGrid}
                />
              ) : (
                getProductCard(item, props, largeCardCount)
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

ProductGrid.propTypes = {
  ageRangeLabel: PropTypes.string,
  title: PropTypes.string,
  noMarginTop: PropTypes.bool,
  fetchPrismicProduct: PropTypes.func,
  media: PropTypes.shape({ fabletDown: PropTypes.bool }),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      product: PropTypes.any,
      savings: PropTypes.shape({
        was_price: PropTypes.shape({
          amount: PropTypes.string.isRequired,
          formatted: PropTypes.string.isRequired,
        }).isRequired,
      }),
      size: PropTypes.oneOf(sizeOptions).isRequired,
    })
  ).isRequired,
};

export default ProductGrid;
